import "./AboutUsStyles.css";

function AboutUs() {
  return(
    <div className="about-container">
      <h1>Our History</h1>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Unde velit cum
        tenetur quam officiis explicabo inventore eligendi, nam sed. Accusamus
        nihil, animi aspernatur dolorum fugiat ab placeat iusto rerum error quas
        autem tempora delectus omnis dolore cupiditate possimus provident
        deserunt!
      </p>

      <h1>Our Mission</h1>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Unde velit cum
        tenetur quam officiis explicabo inventore eligendi, nam sed. Accusamus
        nihil, animi aspernatur dolorum fugiat ab placeat iusto rerum error quas
        autem tempora delectus omnis dolore cupiditate possimus provident
        deserunt!
      </p>

      <h1>Our Vision</h1>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Unde velit cum
        tenetur quam officiis explicabo inventore eligendi, nam sed. Accusamus
        nihil, animi aspernatur dolorum fugiat ab placeat iusto rerum error quas
        autem tempora delectus omnis dolore cupiditate possimus provident
        deserunt!
      </p>
    </div>
  );
}


export default AboutUs;